// extracted by mini-css-extract-plugin
export default {"iconButton":"FilterBoosters_iconButton__K0AbK","activeIcon":"FilterBoosters_activeIcon__dfKPi"};